import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import StickyHeadTable from 'shared/components/table/StickyHeadTable';
import ListGroupItem from 'shared/components/styled/listGroupItem';
import { CardSection } from 'shared/components/cardControls';

const receiverColumns = [
  {
    name: 'Model',
    jsonKey: 'model',
  },
  {
    name: 'Id',
    jsonKey: 'id',
  },
  {
    name: 'Serial No.',
    jsonKey: 'serial_no',
  },
];

/**
 * @param {Object} props
 * @param {Object} props.ticketState
 */
export default function TicketReceivers(props) {
  const {
    ticketState: {
      data: {
        ticket_association: {
          tenant,
        },
      },
    },
  } = props;

  function receiverRows() {
    const receiverArr = [];
    const dtvReceivers = tenant?.dtv_receivers;
    if (dtvReceivers != null) {
      for (let i = 1; i < 7; i += 1) {
        if (dtvReceivers[`r${i}_model`] !== '') {
          receiverArr.push({
            model: dtvReceivers[`r${i}_model`],
            id: dtvReceivers[`r${i}_id`],
            serial_no: dtvReceivers[`r${i}_serial`],
            key: dtvReceivers[`r${i}_model`] + dtvReceivers[`r${i}_id`] + dtvReceivers[`r${i}_serial`],
          });
        }
      }
    }
    return receiverArr;
  }

  return (
    <CardSection>
      <Box sx={{
        padding: '10px', backgroundColor: 'subtleBackground', borderRadius: '.25rem', marginBottom: '5px',
      }}
      >
        <Grid
          container
          size={12}
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          sx={{
            justifyContent: 'space-between',
          }}
        >
          <Grid size={12}>
            <div className="item-child-title">Receivers</div>
          </Grid>
          {tenant?.dtv_receivers
      && (
      <Grid size={12}>
        <ListGroupItem key="account_number" sx={{ width: '250px', marginBottom: '10px' }}>
          <strong>Account Number:</strong>
                &nbsp;
          {tenant?.dtv_receivers?.account_number}
        </ListGroupItem>
      </Grid>
      )}
          <Grid size={12}>
            <StickyHeadTable
              columns={receiverColumns}
              noRowsText="No receivers"
              rowId="key"
              rows={receiverRows()}
              className=""
            />
          </Grid>
          <br />
        </Grid>
      </Box>
    </CardSection>
  );
}
